module.exports = __webpack_public_path__ + "static/grafika8-66c0ac1106cf317c8621ee7a0b9e270f.png";